import { Prohibit } from '@phosphor-icons/react';
import { Topbar } from '@/components/layout/Topbar';
import { PageShell } from '@/components/layout/PageShell';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { useAuth } from '@/hooks/use-auth';
import { useSignOut } from '@/hooks/use-sign-out';
import { supportPhoneLabel, supportWhatsAppUrl } from '@/lib/support-contact';

const CONTACT_MESSAGE =
  'Olá! Entrei na plataforma Clearance mas minha conta não tem acesso. Podem verificar?';

/**
 * Autenticado, sem acesso — hoje é o caso do SUPPLIER, que tem conta mas não
 * alcança nenhuma superfície do clearance.
 *
 * **Não redireciona para o login.** O usuário já está logado: mandá-lo para lá
 * o traria de volta aqui pelo `RequireAuth`, em loop, sem nunca dizer o que
 * houve. A saída é sair da conta ou falar com o operador — as duas oferecidas
 * aqui.
 */
export function NoAccess() {
  const { user } = useAuth();
  const { signOut, leaving } = useSignOut();

  const contactUrl = supportWhatsAppUrl(CONTACT_MESSAGE);
  const phoneLabel = supportPhoneLabel();

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Topbar />
      <main className="flex flex-1 flex-col">
        <PageShell maxWidth="4xl">
          <Card className="mx-auto w-full max-w-xl">
            <CardHeader className="space-y-3">
              <span
                aria-hidden="true"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-border text-muted-foreground"
              >
                <Prohibit size={22} />
              </span>
              <CardTitle>Sua conta não tem acesso a esta área</CardTitle>
              <CardDescription>
                {user?.name ? `${user.name}, o` : 'O'} acesso ao Clearance é
                liberado por conta. A sua está ativa, mas não inclui esta
                superfície.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <p className="text-base leading-relaxed text-muted-foreground">
                Se você deveria ter acesso, fale com quem enviou o seu link
                {phoneLabel ? ` pelo ${phoneLabel}` : ''}. Se entrou com a conta
                errada, saia e entre novamente.
              </p>
              <div className="flex flex-col gap-3 border-t border-border pt-4 sm:flex-row sm:justify-end">
                {contactUrl && (
                  <Button asChild variant="outline">
                    <a href={contactUrl} target="_blank" rel="noreferrer">
                      Falar com o atendimento
                    </a>
                  </Button>
                )}
                <Button onClick={signOut} disabled={leaving}>
                  {leaving ? 'Saindo...' : 'Sair da conta'}
                </Button>
              </div>
            </CardContent>
          </Card>
        </PageShell>
      </main>
    </div>
  );
}
